<div class="widget-item-data">

  <div class="title-wrap">
    <div class="title">{{ title }}</div>
  </div>

  @if (data || data === 0) {

    <div class="data-wrap">

      <div class="data">{{ data }}</div>

      @if (extraData || statusData) {

        <div
          class="extra-data"
          [ngClass]="[statusData]"
        >
          @if (statusData) {
            <yu-icon
              class="status-icon"
              [name]="statusData === 'success' ? 'arrow-circle-up' : 'arrow-circle-down'"
            ></yu-icon>
          }

          <span>{{ extraData }}</span>
        </div>

      }

    </div>

    <ng-content select="[extra-content]"></ng-content>

  } @else {

    <div class="data-wrap">
      <ion-skeleton-text [animated]="true"></ion-skeleton-text>
    </div>

  }

</div>
